<template>
  <div id="app">
    <keep-alive>
      <!--使用keep-alive会将页面缓存-->
      <router-view v-if="$route.meta.keepAlive && isRouterAlive "></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive "></router-view>
    <!-- 敬请期待  coming soon-->
    <div v-show="tipMsg.show" class="coming_soon">
      <div class="coming_soon_bg"></div>
      <div class="coming_soon_text">{{ tipMsg.msg }}</div>
    </div>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale/zh_CN";
import { mapState, mapActions, mapGetters } from "vuex";
import loading from "@/components/loading/loading.vue";
export default {
  name: "App",
  provide(){
    return{
      reload:this.reload
    }
  },
  components: {
    loading
  },
  data() {
    return {
      locale: zhCN,
      coming_soon: "",
      isRouterAlive:true
    };
  },
  created() {
    if (localStorage.getItem("mp_lang")) {
      this.$i18n.locale = localStorage.getItem("mp_lang");
    } else {
      localStorage.setItem("mp_lang", "en");
      this.$i18n.locale = "en";
    }
    // var  self  =this;
    // setTimeout(function() {
    //   document.title = self.$t('router.'+[self.meta.title])
    // }, 500);
  },
  mounted() {
    // var  self  =this;
    // document.title = self.$t('router.'+[self.meta.title])
  },
  watch: {
    $route(to, from) {
      document.title = this.$t("router." + [to.meta.title]);
      return;
    }
  },
  methods: {
    reload(){
      this.isRouterAlive = false
      this.$nextTick(()=>{
        this.isRouterAlive =true
      })
    }
  },
  computed: {
    ...mapState("user", ["tipMsg", "nickname"])
  }
};
</script>

<style>
body,
html {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  position: relative;
}
#app {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  /* overflow-x: hidden; */
}
/* @media screen and (max-width: 1680px) {
  body,
  html {
    overflow: scroll;
    width: 1680px;
  }
  #app {
    width: 1680px;
    height: 100%;
    overflow-x: hidden;
  }
} */

@media screen and (max-width: 1440px) {
  body,
  html {
    /* overflow-x: auto; */
    width: 1440px;
  }
  #app {
    width: 1440px;
    height: 100%;
    /* overflow-x: hidden; */
  }
}

@media screen and (max-width: 1520px) {
  #app .gamelist_box {
    width: 1440px;
  }
  #app .condition {
    width: 1440px;
  }
  #app .Operational_data_box .info_box {
    width: 1440px;
  }
}

.TGA_BOX {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
  width: 100%;
}
.TGA_INPUT_BOX {
  position: relative;
}
.TGA_TEXT {
  line-height: 50px;
  width: 180px;
  text-align: right;
  margin-right: 19px;
  position: absolute;
  top: 0;
  left: -200px;
}
.TGA_INPUT {
  width: 325px;
  height: 50px;
  list-style: none;
  padding: 0 0 0 15px;
  margin: 0;
  border: 1px solid #e5e5e5;
  outline: medium;
  font-size: 14px;
  border-radius: 4px;
}
.TGA_CODE_ACTIVE {
  padding-right: 150px;
}
.TGA_INPUT:focus {
  border: 1px solid #40a9ff;
}
.TGA_INPUT_INIT {
  color: #f65651;
  font-size: 12px;
  position: absolute;
  right: -420px;
  top: 0;
  height: 50px;
  display: flex;
  align-items: center;
  line-height: 50px;
  width: 400px;
}
.TGA_INPUT_INIT img {
  margin-right: 10px;
}

.TGA_BTN {
  cursor: pointer;
  width: 325px;
  height: 50px;
  background-color: #dddddd;
  border-radius: 4px;
  margin: 0 auto;
  color: #fff;
  text-align: center;
  line-height: 50px;
  font-size: 16px;
}

.router_box {
  margin: 20px auto 0;
  width: 325px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.router_register {
  color: #aaaaaa;
  font-size: 14px;
  cursor: pointer;
}
.router_register span {
  color: #4990fa;
}
.router_forget {
  font-size: 14px;
  color: #4990fa;
  cursor: pointer;
}
.TGA_INIT {
  margin-top: 11px;
  font-size: 12px;
  color: #c5c5c5;
}

.TGA_CODE {
  position: absolute;
  top: 0;
  left: 182px;
  width: 125px;
  height: 36px;
  background-color: #dddddd;
  border-radius: 4px;
  margin: 7px 8px;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
  font-size: 12px;
}
.TGA_BR .TGA_INPUT {
  border: solid 1px #f65651 !important;
}
.TGA_BR .TGA_SELECT {
  border: solid 1px #f65651 !important;
}

select {
  color: #cccccc;
}
.SelectPlaceholder {
  color: rgba(28, 28, 28, 1) !important;
}
.TGA_BTN_BOX {
  display: flex;
  justify-content: space-between;
  width: 325px;
  margin: 0 auto;
}
.TGA_BTN_LAST {
  width: 155px;
  height: 50px;
  border-radius: 4px;
  border: solid 1px #4990fa;
  color: #4990fa;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.TGA_BTN_CONFIRM {
  width: 155px;
  height: 50px;
  background-color: #dddddd;
  border-radius: 4px;
  color: #ffffff;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.TGA_BTN_ACTIVE {
  background-color: #4990fa;
}
.CU {
  cursor: pointer;
}
.must {
  font-size: 12px;
  color: red;
  margin-right: 3px;
}
.MG25 {
  margin-top: 25px;
}

.select {
  list-style: none;
  border: 1px solid #e5e5e5;
  width: 117px;
  height: 40px;
  outline: none;
  padding-left: 15px;
}
select::-ms-expand {
  display: none;
}
select {
    appearance: none;
   -moz-appearance: none;
   -webkit-appearance: none;
}
.select:focus {
  border: 1px solid #40a9ff;
}
.selectoption {
  width: 367px;
}
.input367 {
  width: 367px;
  height: 40px;
  border-radius: 4px;
  border: solid 1px #e5e5e5;
}
.list_select {
  display: flex;
  align-items: center;
}
.selectipone {
  width: 85px;
  height: 40px;
  border: solid 1px #e5e5e5;
}

/* 敬请期待弹出框 */
.coming_soon {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.coming_soon_bg {
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.1;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.coming_soon_text {
  position: relative;
  font-size: 12px;
  z-index: 2;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px 40px;
}

::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #cccccc;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #cccccc;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #cccccc;
}

.wid367 {
  width: 367px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
.gamelist_box .ant-table-thead .ant-table-row-cell-break-word {
  border-right: 1px solid #e5e5e5;
}
.gamelist_box .ant-table-pagination.ant-pagination {
  float: none;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 550px;
  width: 100%;
}
.order .ant-table-pagination.ant-pagination {
  float: none;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: -70px;
  width: 100%;
}

.rank_box .ant-table-pagination.ant-pagination {
  float: none;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: -70px;
  width: 100%;
}

.gamelist_box .ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 13px !important;
}

.gamelist_box .ant-table-thead > tr > th {
  background-color: #f5f7fa;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
}
.gamelist_box .ant-table-placeholder {
  border-bottom: none;
}

.order .ant-table-placeholder {
  border-bottom: none;
}
.FoundGame_box .ant-select-selection__choice__content,
.GameInfo .ant-select-selection__choice__content {
  font-size: 14px !important;
}

.gamelist_box .ant-pagination-item-active {
  border: 1px solid #4990fa;
}
.gamelist_box .ant-pagination-item-active a {
  color: #ffffff;
  background-color: #4990fa;
  border: none;
}
.TGA_PD {
  padding-left: 15px;
  padding-right: 15px;
}

.time_data .ant-calendar-picker-input.ant-input,
.overview .ant-calendar-picker-input.ant-input,
.game_analyse .ant-calendar-picker-input.ant-input {
  height: 40px;
}
.overview .ant-calendar-picker-input.ant-input,
.game_analyse .ant-calendar-picker-input.ant-input {
  padding-left: 10px;
}
/* 修改game 的左边菜单 */
.info_box .ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border: none;
}
.info_box .ant-menu {
  background: none;
}
.info_box .ant-menu-inline .ant-menu-submenu-title {
  height: 52px;
  line-height: 52px;
  margin: 0;
  padding-left: 30px !important;
}
.info_box .ant-menu-submenu-title:hover {
  color: rgba(0, 0, 0, 0.65);
}
.info_box .ant-menu-submenu-active {
  color: rgba(0, 0, 0, 0.65);
}

.info_box
  .ant-menu-submenu-inline
  > .ant-menu-submenu-title:hover
  .ant-menu-submenu-arrow::before {
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.65),
    rgba(0, 0, 0, 0.65)
  );
}
.info_box
  .ant-menu-submenu-inline
  > .ant-menu-submenu-title:hover
  .ant-menu-submenu-arrow::after {
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.65),
    rgba(0, 0, 0, 0.65)
  );
}
.info_box .ant-menu-item-active {
  color: rgba(0, 0, 0, 0.65);
}
.info_box .ant-menu-item-selected {
  color: rgba(0, 0, 0, 0.65);
  background: none;
}
.info_box .ant-menu-submenu-selected {
  color: rgba(0, 0, 0, 0.65);
}
.info_box .ant-menu-inline .ant-menu-item::after {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  border-right: none;
  border-left: 4px solid #4990fa;
}
.info_box .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: #ffffff;
}
.info_box .ant-menu-sub.ant-menu-inline .ant-menu-item {
  height: 52px;
  line-height: 52px;
  margin: 0;
  padding-left: 40px !important;
}
.ant-menu-item,
.info_box .ant-menu-inline .ant-menu-item {
  height: 52px;
  line-height: 52px;
  margin: 0;
  padding-left: 30px !important;
}
.info_box .ant-menu-submenu > .ant-menu {
  background: none;
}

/* 排行版的table 修改 */

.rank_API .ant-table-placeholder,
.table_border .ant-table-placeholder {
  border-bottom: none;
}
.rank_API .ant-table-thead .ant-table-row-cell-break-word {
  border-right: 1px solid #e5e5e5;
}
.rank_API .ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 13px !important;
}

.rank_API .ant-table-thead > tr > th {
  background-color: #f5f7fa;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  border-left: 1px solid #e5e5e5;
}
.rank_API .ant-table-thead > tr > th:nth-of-type(1) {
  border-left: none;
}
.rank_API .ant-table-placeholder {
  border-bottom: none;
}

/* 分享的 */
.share_box .ant-collapse-content-box,
.ad_box .ant-collapse-content-box {
  background: #fff;
}
.share_box .ant-collapse-item,
.ad_box .ant-collapse-item {
  background-color: #f5f7fa;
}
.el-tabs__header{
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue